import api from "core/api/axiosInstance";
import { isConcessionResponseKey } from "./conciliationKeyFormat";

export async function getConcessionResponses(code, signal) {
  if (!localStorage.getItem("token"))
    throw new Error("Tu sesión expiró. Inicia sesión nuevamente.");
  if (!/^\d+$/.test(String(code || ""))) throw new Error("Código de concesión inválido.");
  const { data } = await api.get(
    `/api/conciliation/get-conciliations-response/${encodeURIComponent(code)}`,
    { signal, timeout: 15000 }
  );
  if (!data || data.success === false || (data.code != null && Number(data.code) !== 0))
    throw new Error(data?.message || "No se pudieron consultar las respuestas guardadas.");
  if (!Object.prototype.hasOwnProperty.call(data, "data"))
    throw new Error("La consulta de respuestas devolvió un formato inválido.");
  const records = data.data == null ? [] : Array.isArray(data.data) ? data.data : [data.data];
  const latest = new Map();
  const reports = new Map();
  records.forEach((record) => {
    if (!record || typeof record !== "object" || record.code == null || !record.key_concil)
      throw new Error("Una respuesta guardada tiene un formato inválido.");
    if (String(record?.code) !== String(code) || record.deletedAt != null) return;
    let more;
    try {
      more = typeof record.more === "string" ? JSON.parse(record.more) : record.more;
      if (!more || typeof more !== "object" || Array.isArray(more)) more = null;
    } catch (_) {
      more = null;
    }
    const details = Object.values(more || {}).flatMap((peaje) => {
      if (!peaje || typeof peaje !== "object") return [];
      return peaje.steps != null
        ? [peaje]
        : Object.values(peaje).filter((detail) => detail && typeof detail === "object");
    });
    const steps =
      record.steps ??
      (details.length &&
      details.every(
        (detail) => /^\d+$/.test(String(detail.steps)) && Number.isSafeInteger(Number(detail.steps))
      )
        ? details.reduce((total, detail) => total + Number(detail.steps), 0)
        : undefined);
    if (
      !isConcessionResponseKey(record.key_concil) ||
      !/^\d+$/.test(String(steps)) ||
      !Number.isSafeInteger(Number(steps)) ||
      !/^\d+(\.\d+)?$/.test(String(record.value_concil)) ||
      !Number.isFinite(Number(record.value_concil))
    )
      throw new Error("Una respuesta guardada tiene un formato inválido.");
    const storedFile = record.file ?? record.files;
    const fileNameOf = (file) =>
      typeof file === "string"
        ? file.split(/[\\/]/).pop().split("?")[0]
        : file
        ? String(file.originalname || file.filename || "Archivo adjunto registrado")
        : "";
    const files = (Array.isArray(storedFile) ? storedFile : storedFile ? [storedFile] : [])
      .map((file, index) => ({
        fileName: fileNameOf(file),
        peaje: typeof file?.peaje === "string" ? file.peaje.trim() : "",
        index,
      }))
      .filter((file) => file.fileName);
    const normalized = {
      id: record.id,
      key_concil: String(record.key_concil),
      code: String(record.code),
      steps: Number(steps),
      value_concil: Number(record.value_concil),
      observation: String(record.observation || ""),
      more,
      fileName: files.length === 1 ? files[0].fileName : "",
      ...(Array.isArray(storedFile) || files.some((file) => file.peaje) ? { files } : {}),
      user: String(record.user_id || ""),
      createdAt: record.createdAt,
      updatedAt: record.updatedAt,
      persisted: true,
    };
    const previous = latest.get(normalized.key_concil);
    if (!reports.has(normalized.key_concil)) reports.set(normalized.key_concil, []);
    reports.get(normalized.key_concil).push(normalized);
    const time = (item) => Date.parse(item.updatedAt || item.createdAt) || 0;
    if (
      !previous ||
      time(normalized) > time(previous) ||
      (time(normalized) === time(previous) && Number(normalized.id) > Number(previous.id))
    )
      latest.set(normalized.key_concil, normalized);
  });
  return [...latest.values()].map((record) => ({
    ...record,
    reports: reports.get(record.key_concil),
  }));
}
